<template>
    <ValidationObserver ref="validator" tag="div" class="competitorRow">
        <template v-if="item && !isEditing">
            <div class="fake-input" style="flex-basis: 20%; margin-right: 5px;">
                {{ item.competitor.name }}
            </div>
            <div class="fake-input" style="overflow: hidden; text-overflow: ellipsis">
                <a class="text-ellipsis" style="text-decoration:none; height: 20px;" :href="item.url" target="_blank">
                    {{ item.url }}
                </a>
                <div style="white-space: nowrap">
                    <button @click.prevent.stop="edit()" class="tiny redHover" style="margin-bottom: 3px !important;">
                        <i class="fas fa-pencil"></i>
                    </button>
                    <button @click.prevent.stop="remove()" class="tiny redHover" style="margin-bottom: 3px !important;">
                        <i class="fas fa-times red"></i>
                    </button>
                </div>
            </div>
        </template>

        <template v-else>
            <div style="flex-basis: 20%; margin-right: 5px">
                <ValidationProvider v-slot="{ errors }" :rules="`${validationRequired ? 'required' : ''}`">
                    <v-select placeholder="Название"
                              v-model="newRow.competitor.id"
                              :options="competitorsList
                                  .filter((competitor) => canUseThisId(competitor.id))
                                  .map(({ id, name }) => {return { value: id, text: name }})"
                              :class="{'hasError' : errors[0]}"
                              v-tooltip="{content: errors[0], template: tooltipStyle()}"
                              @input="setCompetitor"
                              @change="save"/>
                </ValidationProvider>
            </div>
            <div class="inputWithButton" style="width: 100%">
                <ValidationProvider v-slot="{ errors }" :rules="`${validationRequired ? 'required|url' : ''}`">
                    <input v-model="newRow.url"
                           @blur="save"
                           :class="{'hasError' : errors[0]}"
                           v-tooltip="{content: errors[0], template: tooltipStyle()}">
                </ValidationProvider>
                <button @click.prevent.stop="save" class="tiny greenHover" style="right:22px">
                    <i class="fas fa-check green"></i>
                </button>
                <button @click.prevent.stop="remove" class="tiny redHover">
                    <i class="fas fa-times red"></i>
                </button>
            </div>
        </template>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            competitorsList: {
                type: Array,
                required: true,
            },
            row: {
                type: Object,
                default: null,
            },
            usingIds: {
                type: Array,
                default: () => [],
            },
        },
        data: function () {
            return {
                item: this.row,
                isEditing: false,
                newRow: {
                    url: null,
                    competitor: {
                        id: null,
                        name: null
                    }
                },
            };
        },
        methods: {
            save() {
                if (!this.validationRequired) {
                    return;
                }

                this.$refs.validator.validate().then(success => {
                    if (!success) {
                        return;
                    }

                    this.$emit('save', this.newRow)
                    this.isEditing = false;
                    this.newRow = {
                        url: null,
                        competitor: {
                            id: null,
                            name: null
                        }
                    };
                });
            },
            edit() {
                this.newRow = this.item;
                this.isEditing = true;
            },
            setCompetitor() {
                this.newRow.competitor.name = this.getNameById(this.newRow.competitor.id)
            },
            remove() {
                this.$emit('delete')
            },
            canUseThisId(id) {
                return !this.usingIds.includes(id) || (this.row && this.row.competitor.id === id);
            },
            getNameById(id) {
                return this.competitorsList.find(c => c.id === id).name
            },
            tooltipStyle() {
                return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`
            }
        },
        computed: {
            validationRequired() {
                return Boolean(this.row) || this.newRow.url !== null || this.newRow.competitor.id !== null;
            },
        }
    }
</script>
<style scoped>
    .competitorRow {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 5px;
        height: 23px;
    }
    .fake-input {
        border: 1px solid #dcdcdc;
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-radius: 3px;
        padding: 0 3px;
        height: 23px;
    }
</style>
